import { authAxios } from "../api/axiosClient";
import {
  resultExamURL,
  exportResultExamURL,
  exportExamURL
} from "../constants";

export const getResultExamAPI = (params = {}) => {
  const url = resultExamURL;
  return authAxios().get(url, { params });
};

export const postDownloadResultExamApi = (params = {}) => {
  const url = exportResultExamURL;
  return authAxios().post(url, params, {responseType: 'blob'});
};

export const postDownloadExamApi = (params = {}) => {
  const url = exportExamURL;
  return authAxios().post(url, params, {responseType: 'blob'});
};

